const button = {
    cancel: 'Abbrechen',
    ok: 'OK',

    no: 'Nein',
    yes: 'Ja',
};

export default button;
